import React from 'react'
// ##
import ZonesTable from '../../modules/Zone/components/ZonesTable'

export default function SectionPage() {
  return <ZonesTable />
}
